import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { httpClient } from '../../../../../util/http-client'
import { maturityCompliancesRulesMessages } from '../messages'
import { MaturityComplianceRule } from '../models'

interface DeleteMaturityComplianceRuleProps {
  domain: string
  groupId: number
  rule: MaturityComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteMaturityComplianceRuleModal = ({
  domain,
  groupId,
  rule,
  isVisible,
  onClose,
  onSuccess,
}: DeleteMaturityComplianceRuleProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (groupId: number, ruleId: number) => {
    setIsDeleting(true)

    try {
      await httpClient(`/compliances/maturities/groups/${groupId}/rules/${ruleId}`, {
        method: 'DELETE',
        domain,
      })
      onSuccess()

      notification.success({
        message: maturityCompliancesRulesMessages.common.success,
        description: maturityCompliancesRulesMessages.delete.success,
      })
    } catch (error) {
      notification.error({
        message: maturityCompliancesRulesMessages.common.error,
        description: error.error_message || maturityCompliancesRulesMessages.delete.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete Maturity Compliance Rule"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(groupId, rule.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete
          </Button>
        </div>,
      ]}
    >
      {buildDeleteMessage(rule)}
    </Modal>
  )
}

const buildDeleteMessage = (rule: MaturityComplianceRule) =>
  `Are you sure that you want to delete this maturity compliance rule?\n
  - From: ${rule?.maturityDaysFrom}\n
  - To: ${rule?.maturityDaysTo}\n
  - Min Limit: ${rule?.minLimit}\n
  - Max Limit: ${rule?.maxLimit}\n
  It cannot be reverted`
